// Application Configuration - Generated by installer
// This file contains all configurable settings for the application

const config = {
  // Application Settings
  app: {
    name: 'Saini Ji',
    version: '1.0.0',
    description: 'A comprehensive customer and transaction management system'
  },

  // Admin Credentials
  admin: {
    username: 'Admin',
    password: 'Admin123',
    email: 'hsaini411@gmail.com'
  },

  // Database Configuration
  database: {
    host: 'localhost',
    port: 3306,
    name: 'sainiji',
    username: 'root',
    password: '',
    type: 'mysql'
  },

  // API Configuration
  api: {
    baseUrl: process.env.REACT_APP_API_URL || 'http://localhost/newsite',
    timeout: 30000
  },

  // Storage Configuration
  storage: {
    type: 'localStorage',
    prefix: 'cms_'
  },

  // Business Settings
  business: {
    name: 'Pooja Studio',
    email: 'support@sainisolutions.in',
    phone: '+919170815860',
    website: 'https://sainisolutions.in',
    address: 'ganj muradabad',
    gstNumber: '',
    accountNo: '',
    ifscCode: ''
  },

  // Feature Flags
  features: {
    enableTransactions: true,
    enableInvoices: true,
    enableDocumentUpload: true,
    enablePdfExport: true,
    enableEmailNotifications: false,
    enableSmsNotifications: false
  },

  // UI Configuration
  ui: {
    theme: 'light',
    sidebarCollapsed: false,
    itemsPerPage: 20,
    dateFormat: 'DD/MM/YYYY',
    currency: '₹'
  }
};

export default config;